module.exports = __webpack_public_path__ + "static/media/company-placeholder.de2b1b52.png";